import api from '@/api/index.js'

const canceled_season_tickets_report = {
  state: {
    loading: false,
    reportData: null,
    error: null
  },


  mutations: {
    CANCELED_SEASON_TICKETS_REPORT_LOADING: (state, loading) => {
      state.loading = loading;
    },
    CANCELED_SEASON_TICKETS_REPORT: (state, response) => {
      state.reportData = response;
      state.loading = false;
    },
    CANCELED_SEASON_TICKETS_REPORT_ERROR: (state, error) => {
      state.error = error;
    }
  },

  actions: {
    GetCanceledSeasonTicketsReport({commit}, query) {
      let reqQueryStr = '';
      if (query.period.year) {
        reqQueryStr = `year=${query.period.year}&month=${query.period.month}`
      } else {
        reqQueryStr = `from=${query.period.from}&to=${query.period.to}`
      }
      commit('CANCELED_SEASON_TICKETS_REPORT_ERROR', null)
      commit('CANCELED_SEASON_TICKETS_REPORT', null)
      commit('CANCELED_SEASON_TICKETS_REPORT_LOADING', true)
      return api.get('reports/canceled-season-tickets?' + reqQueryStr)
        .then((response) => {
          commit('CANCELED_SEASON_TICKETS_REPORT', response)
        })
        .catch((error) => {
          commit('CANCELED_SEASON_TICKETS_REPORT_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('CANCELED_SEASON_TICKETS_REPORT_LOADING', false)
        })
    }
  },
}

export default canceled_season_tickets_report
